import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {DecisionGridChangeLogService} from '../../../Services/decision-grid-change-log.service';
import {DecisionGridChangeLogDetailModel} from '../../../Models/decision-grid-change-log-detail-model';

import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { tap } from 'rxjs/operators';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-change-log-details-listing',
  templateUrl: './change-log-details-listing.component.html',
  styleUrls: ['./change-log-details-listing.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class ChangeLogDetailsListingComponent implements OnInit {

  public searchForm: UntypedFormGroup;
  public loading: boolean = false;

  constructor(
    private readonly clientService: ClientService,
    private readonly formBuilder: UntypedFormBuilder,
    public readonly decisionGridChangeLogService: DecisionGridChangeLogService,
    private readonly fileDownload: FileDownloadService,
    public readonly toast: ToastrService
  ) {
  }

  public ngOnInit(): void {

    this.createForm();
    this.loading = true;
    this.decisionGridChangeLogService.getDecisionGridChangeLogDetails(this.clientService.currentClient.id, this.searchForm.value).pipe(
      tap(_ => {

      },
      err => { 
        this.toast.error('Error fetching change logs!', '', { closeButton: true, disableTimeOut: true })
      },
      () => {
        this.loading = false;
      })
    ).subscribe();

  }

  public createForm(): void {
    this.searchForm = this.formBuilder.group({
      username: [''],
      name: [''],
      timestamp: [''],
      action: [''],
      settingsEdited: [''],
    });
  }

  public applyFilters() {
    this.decisionGridChangeLogService.getDecisionGridChangeLogDetails(this.clientService.currentClient.id, this.searchForm.value).subscribe();
  }

  public clearFilters() {
    this.searchForm.controls.username.setValue('');
    this.searchForm.controls.name.setValue('');
    this.searchForm.controls.timestamp.setValue('');
    this.searchForm.controls.action.setValue('');
    this.searchForm.controls.settingsEdited.setValue('');

    this.decisionGridChangeLogService.getDecisionGridChangeLogDetails(this.clientService.currentClient.id, this.searchForm.value).subscribe();
  }

  public downloadSnapshot(model: DecisionGridChangeLogDetailModel) {

    this.decisionGridChangeLogService.FetchSnapshotReportBytes(model.pitLogId).pipe(
      tap(_ => {
        this.fileDownload.HandleFileDownload(_, 'text/csv', 'SnapshotReport.csv');
        this.toast.success('Shapshot report downloaded!');
      },
      err => {
        this.toast.error('Error fetching snapshot report!', '', { disableTimeOut: true, closeButton: true })
      },
      () => {

      })).subscribe();
    
  }
}
